<ng-container *ngIf=" (inputConfig$ | async) as inputConfig">
    <p-treeSelect 
    class="md:w-20rem w-full" 
    containerStyleClass="w-full" 
    [(ngModel)]="selectedStvar" 
    [options]="upravneStvari$ | async" 
    placeholder="<Odaberite klasu>"
    [filter]="true"
    [filterInputAutoFocus]="true"
    (onNodeSelect)="onNodeSelect($event)"
    (onClear)="clearSelection()"
    showClear="true"
    [ngClass]="{ readonly: inputConfig.readOnly }"
    [disabled]="inputConfig.readOnly"/>
</ng-container>

